module.exports = __webpack_public_path__ + "media/images/icons/hex-lead-e829550f18a7ef2a3a8363f5c6bfe210.svg";